<app-accordion>
  <span class="weight-medium is-size-6" title>
      {{
        'cancellation-info.original-fare.original-fare-taxes'
          | translate
      }}
    </span>
  <div class="column" price>
      <span class="is-pulled-right weight-medium">
          {{refundFare.refundTaxesAmount.amount | currency : refundFare.refundTaxesAmount.currency : 'symbol' : '1.2-2' : 'en-US' }}
        </span>
  </div>


  <span content> 
    <div class="column is-offset-1">
      <div class="columns">
        <app-general-fare
          class="is-95-width"
          [priceOnBottom]="true"
          [taxAmount]="refundFare.refundTaxesAmount"
          [taxes]="refundFare.refundTaxes"
          type="taxes"
          title="{{
            'cancellation-info.refund-fare.taxes-refund'
              | translate
          }}"
        ></app-general-fare>
      </div>
    </div>

  <div class="column is-offset-1" >
      <div class="columns">
        <app-general-fare
          class="is-95-width"
          [priceOnBottom]="true"
          type="taxes"
          [noReefundableTaxesTooltip]="'cancellation-info.refund-fare.no-refund-taxes-tooltip'"
          [hasAmountColor]="true"
          [taxAmount]="refundFare.noRefundTaxesAmount"
          [taxes]="refundFare.noRefundTaxes"
          title="{{
            'cancellation-info.refund-fare.no-refund-taxes'
              | translate
          }}"
        ></app-general-fare>
      </div>
    </div>

  </span>
</app-accordion>
